import { FC } from "react";
import { Col, Container, Row } from "reactstrap";
import { AboutTitle } from "../../../constants";
import { AboutContentData } from "../../../data/demo/CarDemo1";
import { dynamicImage, Image } from "../../../utils";
import CommonHeader from "../common/CommonHeader";

const whyItems = [
  "Buy & Sell Used Cars Hassle Free",
  "Fast & Fair Vehicle Valuation",
  "Trusted by Hundreds of Satisfied Customers",
  "Convenient Location in PJ, Selangor",
  "Full Support with Paperwork & Ownership Transfer",
  "No Hidden Fees — Get Paid Instantly",
];

const testimonials = [
  {
    img: "car/about/c1.jpg",
    name: "Mr. Arvind Raj",
    text: "Saya beli Lexus dari CC Autoworld. Kereta bersih, tak accident, semua check dah buat. Staff layan baik, tak pushy. Highly recommended kalau nak cari kereta second hand!",
  },
  {
    img: "car/about/c2.jpg",
    name: "Mr. & Mrs. Lim",
    text: "We found the perfect Toyota Alphard here. Condition was great, price was fair, and the staff was very helpful. The whole experience was smooth and easy. Thank you CC Autoworld!",
  },
  {
    img: "car/about/c3.jpg",
    name: "Mr. Firdaus Ismail",
    text: "Mr. Calvin was very patient and helpful throughout the whole journey. Car is in very good condition and they gave me a very high price for my trade in too. Highly recommend!",
  },
  {
    img: "car/about/c4.jpg",
    name: "Mr. Kiran Kumar",
    text: "Saya beli BMW dari sini sebab nampak review semua bagus. Memang betul! Staff explain every step clearly and even help with insurance. Fast & clear.",
  },
  {
    img: "car/about/c5.jpg",
    name: "Mr. Desmond Wong",
    text: "Unique car, amazing deal! I've always wanted something different and this Fairlady is perfect. CC Autoworld gave me a great deal and excellent service. Love the vibes here!",
  },
  {
    img: "car/about/c6.jpg",
    name: "Mr. Hafiz",
    text: "Saya beli Honda City untuk pakai pergi kerja. Memang best! Staff sangat friendly dan semua urusan selesai dalam 1 hari. Senang, cepat, and trusted dealer.",
  },
];

const AboutOwn: FC<{ header?: boolean }> = ({ header }) => {
  return (
    <section className="car-about-section section-b-space">
      <Container>
        {header && <CommonHeader title={AboutTitle} content={AboutContentData} headClass="title-style-2" animation />}

        <Row className="gy-4 align-items-center">
          <Col lg="6">
            <div className="about-content">
              <span
                className="badge bg-primary bg-opacity-10 text-primary fw-semibold px-3 py-2 mb-3 d-inline-block"
                style={{ borderRadius: "20px", fontSize: "13px" }}
              >
                About Us
              </span>
              <h3 className="mb-1"><strong>CC AUTOWORLD SDN. BHD.</strong></h3>
              <h5 className="mb-3" style={{ color: "#666" }}>Your Trusted Car Dealer in Petaling Jaya (PJ)</h5>

              <p className="mb-3">
                At <b>CC Autoworld Sdn Bhd</b>, we specialize in buying and selling quality used cars in Petaling Jaya. Whether you're looking to buy your dream car or sell your current vehicle, we're committed to delivering transparency, reliability, and value at every step.
              </p>
              <p className="mb-4">
                With years of experience in the Malaysian used car market, we thoroughly inspect every vehicle to our strict quality standards — so you can drive away with full confidence.
              </p>

              <h6 className="fw-bold mb-3">Why Choose CC AUTOWORLD?</h6>
              <Row className="g-2 mb-4">
                {whyItems.map((item, i) => (
                  <Col xs="12" sm="6" key={i}>
                    <div
                      className="d-flex align-items-center gap-2 px-3 py-2"
                      style={{ background: "#f0f4ff", borderRadius: "8px", fontSize: "14px" }}
                    >
                      <span style={{ color: "#2e7d32", flexShrink: 0 }}>✓</span>
                      <span>{item}</span>
                    </div>
                  </Col>
                ))}
              </Row>

              <div className="d-flex gap-3 flex-wrap">
                <a href="/inventory" className="btn btn-solid" style={{ padding: "10px 28px" }}>View Our Inventory</a>
                <a href="/sell-your-car" className="btn btn-outline" style={{ padding: "10px 28px" }}>Sell Your Car</a>
              </div>
            </div>
          </Col>

          <Col lg="6">
            <div className="about-top-img">
              <Image
                src={dynamicImage("car/about/main.jpeg")}
                alt="CC Autoworld Showroom"
                className="img-fluid"
                style={{ borderRadius: "12px" }}
              />
            </div>
          </Col>
        </Row>

        <div className="mt-5 pt-3">
          <CommonHeader
            contentClass="text-black"
            title="What Our Customers Say"
            content="Real stories from happy owners who found their dream cars with CC Autoworld."
            headClass="title-style-3 text-center"
          />
          <Row className="g-4 justify-content-center">
            {testimonials.map((t, i) => (
              <Col lg="4" sm="6" key={i}>
                <div
                  className="h-100 p-3"
                  style={{
                    background: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                    border: "1px solid #f0f0f0",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <Image
                      src={dynamicImage(t.img)}
                      alt={t.name}
                      className="rounded-circle"
                      style={{ width: "52px", height: "52px", objectFit: "cover", flexShrink: 0 }}
                    />
                    <div>
                      <h6 className="fw-bold mb-0" style={{ fontSize: "14px" }}>{t.name}</h6>
                      <div className="text-warning" style={{ fontSize: "11px", lineHeight: 1.4 }}>
                        {[...Array(5)].map((_, j) => <i className="ri-star-fill" key={j}></i>)}
                      </div>
                    </div>
                  </div>
                  <p
                    className="mb-0"
                    style={{ fontSize: "13.5px", lineHeight: "1.65", color: "#555", fontStyle: "italic", flexGrow: 1 }}
                  >
                    "{t.text}"
                  </p>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default AboutOwn;
